import * as actions from './actions';
import reducer from './reducers';
import * as schema from './schema';
import * as selectors from './selectors';

export default reducer;
export { schema, actions, selectors };
